(function (){
    'use strict';

    angular
        .module('elogbooks.user.tasks')
        .config(registerImportRoutes);

    // todo prefix parameters,
    function registerImportRoutes($stateProvider) {
        $stateProvider
            .state('dashboard.user.tasks.generate-planner.imports', {
                url: '/imports',
                parent:'dashboard.user.tasks.generate-planner',
                abstract: true,
                views: parseBook({
                    'task-generate-planner': {
                        templateUrl: 'shared-templates/view.html'
                    }
                }),
                ncyBreadcrumb: {
                    skip: true
                },
                data: {
                    modules: ['tasks']
                },
            })
            .state('dashboard.user.tasks.generate-planner.imports.list', {
                url: '/list?page&limit&order&type',
                parent: 'dashboard.user.tasks.generate-planner.imports',
                views: parseBook({
                    'elogbooks-right@dashboard.user.tasks.generate-planner.imports': {
                        templateUrl: '/modules/common/imports/list/list.html',
                        controller : 'CommonImportListController',
                        controllerAs: 'vm'
                    }
                }),
                resolve: {
                    importsCollectionResponse: function (apiClient, rootResourceResponse, $stateParams) {
                        return apiClient.get(rootResourceResponse.getLink('imports'), $stateParams);
                    },
                    userCollectionResponse: function () {
                        return null;
                    }
                },
                params: {
                    page: '1',
                    limit: '30',
                    type: 'user_asset_task'
                },
                ncyBreadcrumb: {
                    label: '{{ ::"TASK_IMPORTS" | translate }}'
                }
            })
            .state('dashboard.user.tasks.generate-planner.imports.list.details', {
                url: '{importResource}/details?logsPage&logsLimit&logsOrder&logsType&logsMessage',
                parent: 'dashboard.user.tasks.generate-planner.imports.list',
                views: parseBook({
                    'elogbooks-right@dashboard.user.tasks.generate-planner.imports': {
                        templateUrl: '/modules/common/imports/details/details.html',
                        controller : 'CommonImportDetailsController',
                        controllerAs: 'vm'
                    }
                }),
                params: {
                    logsPage: '1',
                    logsLimit: '30',
                    logsType: null,
                    logsMessage: null
                },
                resolve: {
                    importResponse: function (apiClient, $stateParams) {
                        return apiClient.get($stateParams.importResource.decode());
                    },
                    importLogsCollectionResponse: function (apiClient, importResponse, $stateParams) {
                        var params = {
                            page: $stateParams.logsPage,
                            limit: $stateParams.logsLimit,
                            type: $stateParams.logsType,
                            message: $stateParams.logsMessage
                        };
                        return apiClient.get(importResponse.getLink('logs'), params);
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"IMPORT_DETAILS_LIST" | translate }}'
                }
            })
            .state('dashboard.user.tasks.generate-planner.imports.list.add', {
                url: '/add',
                parent: 'dashboard.user.tasks.generate-planner.imports.list',
                views: parseBook({
                    'elogbooks-right@dashboard.user.tasks.generate-planner.imports': {
                        templateUrl: '/modules/common/imports/add/import-add.html',
                        controller: 'CommonAddImportController',
                        controllerAs: 'vm'
                    }
                }),
                resolve: {
                    sectionResource: function() {
                        return {
                            type: 'user_asset_task',
                            name: 'user_asset_task'
                        };
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"IMPORT_ADD" | translate }}'
                }
            });
    }
})();
